import { useState } from "react";
import { useNavigate } from "react-router-dom";

const SettingWifi = () => {
  const navigate = useNavigate();
  const [wifiName, setWifiName] = useState("");
  const [wifiPassword, setWifiPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSaveWifi = async () => {
    if (!wifiName || !wifiPassword) {
      alert("Vui lòng nhập đầy đủ thông tin Wi-Fi!");
      return;
    }

    try {
      setSaving(true);

      const response = await fetch("http://192.168.4.1:8000/connect-wifi", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ssid: wifiName,
          password: wifiPassword,
          child_name: "",
          child_id: ""
        }),
      });

      if (!response.ok) throw new Error("Kết nối thất bại!");

      const result = await response.json();
      console.log("Kết quả:", result);

      alert("✅ Gửi Wi-Fi thành công, đang kết nối...");
      navigate("/41-home");
    } catch (err) {
      alert("❌ Gửi Wi-Fi thất bại. Vui lòng kiểm tra kết nối với robot.");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="font-text-regular-lowercase relative bg-light-primary-key-background w-full min-h-screen overflow-hidden flex flex-col items-center justify-center gap-6 px-4 py-6">
      {/* Nút quay lại */}
      <div className="absolute top-4 left-4">
        <button
          onClick={() => navigate(-1)}
          className="bg-[#FFF2EA] text-[#FF8C92] rounded-full px-4 py-2 shadow font-semibold flex items-center gap-1"
        >
          <span className="text-lg">←</span> Quay lại
        </button>
      </div>

      <div className="w-full max-w-md flex flex-col gap-4 bg-white p-6 rounded-2xl shadow-lg">
        <h2 className="text-xl font-semibold text-pink-500 text-center">
          Kết nối Wi-Fi
        </h2>

        <label className="text-sm font-medium">Tên Wi-Fi</label>
        <input
          type="text"
          placeholder="Nhập tên Wi-Fi"
          value={wifiName}
          onChange={(e) => setWifiName(e.target.value)}
          className="border border-gray-300 rounded-xl px-4 py-2 w-full focus:outline-none"
        />

        <label className="text-sm font-medium">Mật khẩu Wi-Fi</label>
        <input
          type="password"
          placeholder="Nhập mật khẩu Wi-Fi"
          value={wifiPassword}
          onChange={(e) => setWifiPassword(e.target.value)}
          className="border border-gray-300 rounded-xl px-4 py-2 w-full focus:outline-none"
        />

        <button
          onClick={handleSaveWifi}
          disabled={saving}
          className="bg-gradient-to-r from-pink-400 to-orange-300 text-white px-4 py-2 rounded-full font-semibold mt-2 w-full"
        >
          {saving ? "Đang gửi..." : "Gửi đến robot"}
        </button>
      </div>
    </div>
  );
};

export default SettingWifi;